export default __webpack_public_path__ + "static/media/Women_en.126804e7.svg";